import { Navigate, useParams } from 'react-router-dom';
import { APP_LINKS } from '@/helpers/links';
import FlexibilityPageV1 from './versions/v1';

const VERSIONS = ['v1'];

const LoanTermsFlexibilityPage = () => {
  const { version } = useParams();

  if (version && !VERSIONS.includes(version)) {
    return <Navigate to={APP_LINKS.loanTermsFlexibility()} replace />;
  }

  switch (version) {
    case 'v1':
    default:
      return <FlexibilityPageV1 />;
  }
};

export default LoanTermsFlexibilityPage;
